
  import { defineComponent, PropType } from 'vue';

  import InputBlock from '@/common/components/redesigned/InputBlock.vue';
  import SelectMultiComponent from '@/common/components/SelectMultiComponent.vue';
  import { getNextYear } from '@/common/utils/year';

  import { ALL_YEAR_OPTION } from '../../constants/dashboards';
  import { TDashboardMainFilter, TDashboardMainFilterWithOptionalYear } from '../../types/dashboards';
  import { getDashboardsYearsOptions } from '../../utils/years';

  export default defineComponent({
    name: 'DashboardsYearFilterBlock',
    components: {
      SelectMultiComponent,
      InputBlock,
    },
    emits: {
      changeFilter: (value: TDashboardMainFilter) => value,
    },
    props: {
      filter: {
        type: Object as PropType<TDashboardMainFilterWithOptionalYear>,
        required: true,
      },
    },
    data(): {
      localFilter: TDashboardMainFilterWithOptionalYear;
    } {
      return {
        localFilter: { ...this.filter },
      };
    },
    computed: {
      getYearsOptions() {
        const nextYear = String(getNextYear());

        return [...getDashboardsYearsOptions(), { value: nextYear, label: nextYear }, ALL_YEAR_OPTION];
      },
    },
    watch: {
      localFilter: {
        handler(value: TDashboardMainFilter) {
          this.$emit('changeFilter', value);
        },
        deep: true,
      },
    },
  });
